import "./styles.scss";

type ButtonProps = {
  type?: "button" | "link";
  text?: string;
  href?: string;
  icon?: React.ReactNode;
  icon_direction?: "left" | "right";
  is_icon?: boolean;
  className?: string;
  onClick?: () => void;
};

export default function Button({
  type,
  text,
  href,
  icon = null,
  icon_direction = "left",
  is_icon = false,
  className,
  onClick,
}: ButtonProps) {
  const getClassNames = (classNames) => {
    if (!classNames) return "";

    return classNames
      .split(" ")
      .map((cls) => cls)
      .join(" ");
  };

  const iconClass = is_icon ? "btn_new_icon" : "";
  const buttonClasses = `btn_new ${iconClass} ${getClassNames(
    className
  )}`;

  if (type === "button") {
    return (
      <button className={buttonClasses} onClick={onClick} type="button">
        {icon_direction === "left" && icon}
        {text && <span>{text}</span>}
        {icon_direction === "right" && icon}
      </button>
    );
  }

  return (
    <a href={href} className={buttonClasses} onClick={onClick}>
      {icon_direction === "left" && icon}
      {text && <span>{text}</span>}
      {icon_direction === "right" && icon}
    </a>
  );
}
